/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
    Spinner
} from "reactstrap";

const MainReportTotal1 = ({ ...props }) => {
    const [dataa, setdataa] = useState([])
    const [totall2, settotall2] = useState([])
    const [load, setload] = useState(true)
    const getdata = async () => {
        const sendData = {
            ParametersId: Number(props.parametersId),
            YearId: Number(props.year),
            ToYearId: Number(props.toyear),
            ToMonthId: Number(props.tomonth),
            MonthId: Number(props.Month)
        }
        //////console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Reporttotaltradeparam', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data.length > 0) {
                        setdataa(data[0])
                    } else {
                        setdataa([])
                    }
                    ////console.log(data[0])
                    setload(false)
                })

    };

    
    const JobTotal = async () => {
        const sendData = {
            ParametersId: Number(218),
            YearId: Number(props.year),
            MonthId: Number(props.Month),
            ToYearId: Number(props.toyear),
            ToMonthId: Number(props.tomonth),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Reporttotal', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data.length > 0) {
                        settotall2(data[0])
                    } else {
                        settotall2([])
                    }
                    setload(false)
                })

    };
    useEffect(() => {
        setload(true)
        getdata()
        JobTotal()
    }, [props.parametersId, props.UserId, props.generate])

    return (
        <>
            {load ? <Spinner color="success" /> :
                <>{props.emp === 1 && props.parametersId === 218 ?

                            < td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                <label> {totall2.genderTransgender6 ? totall2.genderTransgender6 : 0}</label>

                            </td> : props.emp === 2 && props.parametersId === 218 ? < td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                <label> {dataa.genderFemale5 >= 0 ? dataa.genderFemale5 : 0}</label>

                    </td> :  < td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.casteSc7 >= 0 ? dataa.casteSc7 : 0}</label>

                    </td>}


                </>

            }</>
    );
};

export default MainReportTotal1;
